var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktokGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8044 0H9.77086V12.2608C9.77086 13.7218 8.60414 14.9218 7.1522 14.9218C5.70025 14.9218 4.53352 13.7218 4.53352 12.2608C4.53352 10.8261 5.67433 9.65215 7.07443 9.6V6.52175C3.98904 6.5739 1.5 9.10435 1.5 12.2608C1.5 15.4435 4.04089 18 7.17814 18C10.3153 18 12.8562 15.4174 12.8562 12.2608V5.9739C13.997 6.8087 15.3971 7.30435 16.875 7.33045V4.25217C14.5934 4.17391 12.8044 2.29565 12.8044 0Z",
    fill: "url(#paint0_linear_9827_36313)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9827_36313",
    x1: 2.49485,
    y1: -3.07656e-7,
    x2: 23.6672,
    y2: 19.6194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#9360A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46B7E9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokGradient);
export default __webpack_public_path__ + "static/media/tiktokGradient.3e00e0bb95cee93e8f381632e883c4b9.svg";
export { ForwardRef as ReactComponent };